import { yandexMap } from 'feature/addresses/redux/addressCreateSelector'
import {
  NeareatServiceCenter,
  ServiceDetailAddress,
  ServiceDetailContacts,
  ServiceDetailSchedule,
} from 'feature/serviceCenters/components'
import { TService } from 'feature/serviceCenters/types'
import { ControlsType, MarkType } from 'feature/YandexMap/types'
import { YandexMap } from 'feature/YandexMap/YandexMap'
import { useAppSelector } from 'store/hooks'
import { InformationBlock } from 'widget/InformationBlock/InformationBlock'
import parse from 'html-react-parser'

import style from './ServiceCenterInformation.module.scss'

type TServiceCenterInformation = {
  id: string | undefined
  service: TService
}
// информация на детальной странице сц
export const ServiceCenterInformation = ({
  id,
  service,
}: TServiceCenterInformation) => {
  const { userGeo } = useAppSelector(yandexMap)

  return (
    <>
      <YandexMap
        className={style.serviceMap}
        marks={[MarkType.staticMark, MarkType.geolocationMark]}
        isMapClickable={false}
        hideControls
        controls={[
          ControlsType.ZoomControl,
          ControlsType.GeolocationControlUnit,
          ControlsType.RoutePanel,
        ]}
      />

      {(id === 'geo-address' || id === 'user-address') && userGeo.address && (
        <NeareatServiceCenter pageType={id} address={userGeo.address} />
      )}
      <div className={style.informationBlock}>
        <ServiceDetailAddress service={service} />

        {service.description && (
          <InformationBlock title='Описание'>
            <div className={style.description}>
              {parse(service.description)}
            </div>
          </InformationBlock>
        )}

        {(service.phone || service.email) && (
          <ServiceDetailContacts
            phoneNumber={service.phone}
            email={service.email}
          />
        )}

        {service.weekdaysStart && service.weekdaysEnd && (
          <ServiceDetailSchedule service={service} />
        )}
      </div>
    </>
  )
}
